var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classnames,style:({ cursor: _vm.cursor, userSelect: _vm.userSelect }),on:{"mousedown":_vm.onMouseDown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }